/**
 * Funções do Carrinho no Checkout
 * Gerencia quantidade, remoção de produtos, cupons e atualização de totais via AJAX
 */

(function ($) {
  "use strict";

  const CheckoutCart = {
    init: function () {
      this.bindEvents();
    },

    bindEvents: function () {
      // Atualizar quantidade
      $(document).on(
        "click",
        ".qty-decrease, .qty-increase",
        this.handleQuantityChange.bind(this)
      );

      // Remover produto
      $(document).on(
        "click",
        ".cart-item-remove",
        this.handleRemoveItem.bind(this)
      );

      // Aplicar cupom
      $(document).on(
        "click",
        "#btnApplyCouponCheckout",
        this.handleApplyCoupon.bind(this)
      );

      // Remover cupom
      $(document).on(
        "click",
        ".remove-coupon",
        this.handleRemoveCoupon.bind(this)
      );

      // Enter no campo de cupom
      $(document).on("keypress", "#checkoutCouponCodeInput", function (e) {
        if (e.which === 13) {
          e.preventDefault();
          $("#btnApplyCouponCheckout").click();
        }
      });
    },

    /**
     * Atualizar quantidade do produto
     */
    handleQuantityChange: function (e) {
      e.preventDefault();

      const $button = $(e.currentTarget);
      const cartKey = $button.data("cart-key");
      const $cartItem = $button.closest(".checkout-cart-item");
      const $qtyInput = $cartItem.find(".qty-input");
      let currentQty = parseInt($qtyInput.val());

      // Determina se é incremento ou decremento
      const isIncrease = $button.hasClass("qty-increase");
      const newQty = isIncrease ? currentQty + 1 : Math.max(1, currentQty - 1);

      // Previne quantidade menor que 1
      if (newQty < 1) return;

      // Atualiza visualmente (feedback imediato)
      $qtyInput.val(newQty);

      // Desabilita botões durante o request
      this.setLoadingState($cartItem, true);

      // Faz a requisição AJAX
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        data: {
          action: "update_cart_item_quantity",
          cart_item_key: cartKey,
          quantity: newQty,
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success) {
            this.updateCartTotals(response.data);
            this.refreshCheckoutReview();
            this.showNotification("Quantidade atualizada!", "success");
          } else {
            // Reverte o valor em caso de erro
            $qtyInput.val(currentQty);
            this.showNotification(
              response.data.message || "Erro ao atualizar quantidade",
              "error"
            );
          }
        },
        error: () => {
          // Reverte o valor em caso de erro
          $qtyInput.val(currentQty);
          this.showNotification("Erro ao atualizar quantidade", "error");
        },
        complete: () => {
          this.setLoadingState($cartItem, false);
        },
      });
    },

    /**
     * Remover produto do carrinho
     */
    handleRemoveItem: function (e) {
      e.preventDefault();

      const $button = $(e.currentTarget);
      const cartKey = $button.data("cart-key");
      const $cartItem = $button.closest(".checkout-cart-item");

      // Confirmação opcional
      if (!confirm("Deseja remover este produto do carrinho?")) {
        return;
      }

      // Feedback visual
      $cartItem.addClass("removing");

      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        data: {
          action: "remove_cart_item",
          cart_item_key: cartKey,
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success) {
            // Remove o item com animação
            $cartItem.fadeOut(300, function () {
              $(this).remove();

              // Verifica se o carrinho ficou vazio
              if ($(".checkout-cart-item").length === 0) {
                this.showEmptyCart();
              }
            });

            this.updateCartTotals(response.data);
            this.refreshCheckoutReview();
            this.showNotification("Produto removido!", "success");
          } else {
            $cartItem.removeClass("removing");
            this.showNotification(
              response.data.message || "Erro ao remover produto",
              "error"
            );
          }
        },
        error: () => {
          $cartItem.removeClass("removing");
          this.showNotification("Erro ao remover produto", "error");
        },
      });
    },

    /**
     * Aplicar cupom de desconto
     */
    handleApplyCoupon: function (e) {
      e.preventDefault();

      const $input = $("#checkoutCouponCodeInput");
      const couponCode = $input.val().trim();
      const $button = $("#btnApplyCouponCheckout");

      if (!couponCode) {
        this.showNotification("Digite um código de cupom", "warning");
        return;
      }

      // Loading state
      $button.prop("disabled", true).text("Aplicando...");
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        data: {
          action: "apply_coupon",
          coupon_code: couponCode,
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success) {
            $input.val("");
            this.updateCartTotals(response.data);
            this.addCouponToList(couponCode);
            this.showNotification("Cupom aplicado com sucesso!", "success");
          } else {
            this.showNotification(
              response.data.message || "Cupom inválido",
              "error"
            );
          }
        },
        error: () => {
          this.showNotification("Erro ao aplicar cupom", "error");
        },
        complete: () => {
          $button.prop("disabled", false).text("Aplicar");
        },
      });
    },

    /**
     * Remover cupom
     */
    handleRemoveCoupon: function (e) {
      e.preventDefault();

      const $button = $(e.currentTarget);
      const couponCode = $button.data("coupon");
      const $couponItem = $button.closest(".coupon-applied-item");

      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        data: {
          action: "remove_coupon",
          coupon_code: couponCode,
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success) {
            $couponItem.fadeOut(300, function () {
              $(this).remove();
            });
            this.updateCartTotals(response.data);
            this.refreshCheckoutReview();
            this.showNotification("Cupom removido", "success");
          } else {
            this.showNotification("Erro ao remover cupom", "error");
          }
        },
        error: () => {
          this.showNotification("Erro ao remover cupom", "error");
        },
      });
    },

    /**
     * Atualizar totais do carrinho
     */
    updateCartTotals: function (data) {
      // Re-renderiza a lista de métodos de entrega APENAS se a lista de IDs
      // disponíveis mudou em relação ao que está no DOM. Isso evita que uma
      // resposta com a mesma lista (ex: response do save_shipping_method)
      // re-renderize os radios e perca a seleção do usuário.
      if (
        Array.isArray(data.shipping_methods) &&
        typeof window.jabuticabaRefreshShippingMethods === "function"
      ) {
        const currentIds = Array.from(
          document.querySelectorAll('input[type="radio"][name="shipping_method[0]"]'),
        )
          .map((r) => r.value)
          .filter(Boolean)
          .sort()
          .join(",");
        const newIds = data.shipping_methods
          .map((m) => m.id)
          .sort()
          .join(",");
        const listChanged = currentIds !== newIds;

        if (listChanged) {
          const previousSelected = $('input[name="shipping_method[0]"]:checked').val();
          const stillAvailable = data.shipping_methods.some(
            (m) => m.id === previousSelected,
          );
          window.jabuticabaRefreshShippingMethods(
            data.shipping_methods,
            data.cart_subtotal_raw,
            data.shipping_methods_default_id,
          );
          // Se o método antes selecionado sumiu (ex: Frete Grátis perdeu o
          // min_amount), o re-render marcou o primeiro radio como default.
          // Avisa o backend e atualiza o total exibido.
          if (previousSelected && !stillAvailable) {
            const newMethodId = $('input[name="shipping_method[0]"]:checked').val();
            if (newMethodId) {
              $.ajax({
                url: checkoutCartParams.ajax_url,
                type: "POST",
                dataType: "json",
                data: {
                  action: "save_shipping_method",
                  nonce: checkoutCartParams.nonce,
                  shipping_method: newMethodId,
                },
                success: (resp) => {
                  if (resp && resp.success && resp.data) {
                    const t = parseFloat(resp.data.cart_total || 0);
                    const formatted = t.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    });
                    $("#totalWithShipping").text(formatted);
                    $("#paymentTotalWithShipping").text(formatted);
                    $(".checkout-cart-total .total-value").html(formatted);
                  }
                },
              });
            }
          }
        }
      }

      if (data.subtotal) {
        $(".subtotal-value").html(data.subtotal);
      }

      if (data.total) {
        $(".total-value").html(data.total);
      }

      // Atualiza ou mostra/oculta o desconto
      if (data.has_discount && data.discount) {
        let $discountRow = $(".checkout-cart-discount");

        if ($discountRow.length === 0) {
          // Cria a linha de desconto se não existir
          const discountHTML = `
            <div class="checkout-cart-discount">
              <span class="discount-label">Desconto</span>
              <span class="discount-value">-${data.discount}</span>
            </div>
          `;
          $(".checkout-cart-coupons-applied").after(discountHTML);
        } else {
          // Atualiza o valor do desconto
          $discountRow.find(".discount-value").html("-" + data.discount);
          $discountRow.show();
        }
      } else {
        // Remove a linha de desconto se não houver cupom
        $(".checkout-cart-discount").hide();
      }

      // Atualiza contador do carrinho (se existir)
      if (data.cart_count !== undefined) {
        $(".cart-count").text(data.cart_count);
      }

      // Atualiza o item brinde dinamicamente
      console.log('[BRINDE] gift_html recebido:', data.gift_html);
      console.log('[BRINDE] gift_html undefined?', data.gift_html === undefined);
      console.log('[BRINDE] .gift-item no DOM:', $(".checkout-cart-items .gift-item").length);
      if (data.gift_html !== undefined) {
        $(".checkout-cart-items .gift-item").remove();
        if (data.gift_html) {
          $(".checkout-cart-items").append(data.gift_html);
          console.log('[BRINDE] item adicionado ao DOM');
        } else {
          console.log('[BRINDE] gift_html vazio — brinde removido do DOM');
        }
      }

      // ===== ATUALIZA TOTAL COM ENTREGA =====
      // Sempre recalcula quando o total do carrinho muda (quantidade, cupom, etc)
      const $shippingSection = $(".shipping-total-section");
      const $totalWithShipping = $("#totalWithShipping");

      if ($totalWithShipping.length > 0) {
        // Pega o método de entrega selecionado
        const $selectedShipping = $('input[name="shipping_method"]:checked');

        if ($selectedShipping.length > 0) {
          const shippingCost = parseFloat($selectedShipping.data("cost") || 0);

          // Pega o valor bruto do total (JÁ COM desconto de cupom aplicado)
          const cartTotalRaw = data.total_raw || data.total;
          let cartTotal = 0;

          if (typeof cartTotalRaw === 'number') {
            cartTotal = cartTotalRaw;
          } else if (typeof cartTotalRaw === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = cartTotalRaw;
            const cleanedString = tempDiv.textContent || tempDiv.innerText || '';
            let numericString = cleanedString
              .replace(/R\$|€|\$|£/g, '')
              .replace(/\s/g, '')
              .trim();
            const lastDotPos = numericString.lastIndexOf('.');
            const lastCommaPos = numericString.lastIndexOf(',');
            const length = numericString.length;
            const dotIsDecimal = lastDotPos > -1 && (length - lastDotPos) <= 3;
            const commaIsDecimal = lastCommaPos > -1 && (length - lastCommaPos) <= 3;

            if (commaIsDecimal && !dotIsDecimal) {
              numericString = numericString.replace(/\./g, '').replace(',', '.');
            } else if (dotIsDecimal && !commaIsDecimal) {
              numericString = numericString.replace(/,/g, '');
            } else if (dotIsDecimal && commaIsDecimal) {
              if (lastCommaPos > lastDotPos) {
                numericString = numericString.replace(/\./g, '').replace(',', '.');
              } else {
                numericString = numericString.replace(/,/g, '');
              }
            }
            cartTotal = parseFloat(numericString);
          }

          const totalWithShippingValue = cartTotal + shippingCost;
          const formattedTotal = totalWithShippingValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          });

          $totalWithShipping.text(formattedTotal);

          if ($shippingSection.is(':hidden')) {
            $shippingSection.fadeIn(300);
          }

          $("#paymentTotalWithShipping").text(formattedTotal);
        }
      }
    },

    /**
     * Adicionar cupom à lista de cupons aplicados
     */
    refreshCheckoutReview: function () {
      const $checkoutForm = $("form.checkout");
      const $orderReview = $("#order_review");

      if (!$checkoutForm.length || !$orderReview.length) {
        return;
      }

      $(document.body).trigger("update_checkout");
    },

    addCouponToList: function (couponCode) {
      let $container = $(".checkout-cart-coupons-applied");

      // Cria container se não existir
      if ($container.length === 0) {
        $container = $('<div class="checkout-cart-coupons-applied"></div>');
        $(".checkout-cart-coupon").after($container);
      }

      const couponHTML = `
        <div class="coupon-applied-item">
          <span class="coupon-code">${couponCode}</span>
          <button class="remove-coupon" data-coupon="${couponCode}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      `;

      $container.append(couponHTML);
    },

    /**
     * Mostrar carrinho vazio
     */
    showEmptyCart: function () {
      const emptyHTML = `
        <div class="checkout-cart-empty">
          <p>Seu carrinho está vazio.</p>
        </div>
      `;

      $(".checkout-cart-items").html(emptyHTML);
      $(
        ".checkout-cart-subtotal, .checkout-cart-coupon, .checkout-cart-total"
      ).hide();
    },

    /**
     * Define estado de loading
     */
    setLoadingState: function ($element, isLoading) {
      if (isLoading) {
        $element.addClass("is-loading").find("button").prop("disabled", true);
      } else {
        $element
          .removeClass("is-loading")
          .find("button")
          .prop("disabled", false);
      }
    },

    /**
     * Mostrar notificação
     */
    showNotification: function (message, type = "info") {
      // Você pode integrar com sua biblioteca de notificações existente
      // Ou criar um sistema simples de notificações
      // Exemplo simples de notificação
      const $notification = $(`
        <div class="checkout-notification ${type}">
          ${message}
        </div>
      `);

      $("body").append($notification);

      setTimeout(() => {
        $notification.addClass("show");
      }, 10);

      setTimeout(() => {
        $notification.removeClass("show");
        setTimeout(() => $notification.remove(), 300);
      }, 3000);
    },
  };

  // Inicializa quando o documento estiver pronto
  $(document).ready(function () {
    CheckoutCart.init();
  });
})(jQuery);
